export const devEnv = process.env["NODE_ENV"] === "development";

export const dev = false;

export const devOptions = {
  showAutoTranslationSettings: true,
};
